
import React  from 'react';
import styles from  './Investments.module.css';
import LimitedAdvise from '../components/LimitedAdvise'; 
import MyInvestments from '../components/MyInvestments';
import { useSelector } from 'react-redux';

function Investments() {     
    const { isPremium } = useSelector(state => state.globalData);   

    return (
        <>
        

        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Investments</h1>
            </header>            
            <main>
                <section className={styles.content} style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                  {!isPremium && (          
                      <><div style={{ position: 'absolute', right: '8%' }}>
                              <LimitedAdvise
                                  width="80px"
                                  height="20px"
                                  message="Limited"
                                  tooltipTitle="Why it's limited?"
                                  tooltipPhrases={["Free registration for a maximum of 3 investments!"]}
                                  tooltipPosition="left" // Options: top, down, left, right
                                  tooltipWidth="250px" />
                          </div><br /><br /></>                
                  )}                
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                    <MyInvestments/>
                  </div>
                </section>
            </main>                     
        </div></>
    );
}

export default Investments;



  






